import TechHeader from "@/components/Techs/TechHeader.vue";
import TechList from "@/components/Techs/TechList.vue";
import TechEdit from "@/components/Techs/TechEdit.vue";
import TechFilter from "@/components/Techs/TechFilter.vue";

export default [
    {
        path: 'tech',
        alias: 'techs',
        name: 'All Techs',
        redirect: "/tech/list",
        components: {
            page: TechList,
            header: TechHeader
        },
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        children: [
            {
                path: "filter",
                name: "Tech Filter",
                components: {
                    modal: TechFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Tech List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "edit/:id",
                name: "Tech Edit",
                components: {
                    modal: TechEdit,
                }
            }
        ]
    }
];